
import { mapActions } from 'vuex';
export default {
    name: "blogger-ranking-channel",
    props: ["api_id", "category_id", "title_text", "channel_id", "pa_page_name"],
    data(){
        return {
            rank_status: 1, // 1的時候是熱門，2的時候是新星
            pa_text: "熱門",
            random_default_img: Math.floor(Math.random()*3)
        }
    },
    computed: {
        top_one() {
            return this.$store.state.blogger.blogger_top_rank;
        },
        other_blogger() {
            return this.$store.state.blogger.blogger_ranking_data.slice(1);
        },
        all_blogger() {
            return this.$store.state.blogger.blogger_ranking_data;
        },
        model_id() {
            return this.$store.state.blogger.blogger_top_rank_model_id;
        },
        router_name() {
            return this.$route.name;
        },
    },
    methods: {
        ...mapActions('blogger', [
            'getBloggerTopRankingData',
            'getBloggerNewRankingData'
        ]),
        async switchBloggerRank(tab_id) {
            if ( this.rank_status != tab_id ) {
                this.rank_status = tab_id;
                if(this.rank_status == 1) {
                    let params;
                    if (this.category_id != 0 && this.category_id != "" && this.category_id != undefined) {
                        params = { page_size: 5, api_id: this.api_id, with_blog: 1, with_counter: 1, with_articles: 1, with_profile: 1, category_id: this.category_id }
                    } else {
                        params = { page_size: 5, api_id: this.api_id, with_blog: 1, with_counter: 1, with_articles: 1, with_profile: 1, channel_id: this.channel_id }
                    }
                    this.pa_text = "熱門";
                    await this.$store.dispatch("blogger/getBloggerTopRankingData", params);
                } else {
                    this.pa_text = "新星";
                    let params;
                    if (this.category_id != 0 && this.category_id != "" && this.category_id != undefined) {
                        params = { page_size: 5, api_id: this.api_id, with_blog: 1, with_counter: 1, with_articles: 1, with_profile: 1, category_id: this.category_id }
                    } else {
                        params = { page_size: 5, api_id: this.api_id, with_blog: 1, with_counter: 1, with_articles: 1, with_profile: 1, channel_id: this.channel_id }
                    }
                    await this.$store.dispatch("blogger/getBloggerNewRankingData", params);
                }
            }
        },
        formatteNumber(num){
            const formatter = new Intl.NumberFormat('zh-Hant-TW', {
                /** decimal：純數字 currency：貨幣 percent：百分比 unit：單位 */
                style: 'decimal',
                minimumFractionDigits: 0
            });
            return formatter.format(num);
        },
        paFunction(blog_data, index) {
            window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'imps::部落客排行::blogger_card::'+ this.model_id, '部落客排行/'+ this.pa_text + '::' + blog_data , '1.000'+ index ]);
        },
        paClickFunction(blog_data, index) {
            window._piq.push(['trackEvent', 'rs2022::十大頻道::' + this.pa_page_name, 'click::部落客排行::blogger_card::'+ this.model_id, '部落客排行/'+ this.pa_text + '::' + blog_data , '1.000' + index]);
        },
        visibilityChanged(isVisible, entry) {
            if (entry.intersectionRatio > 0) {
                this.isVisible = isVisible
                for(let i = 0; i < 5; i++ ) {
                    let blogger_text = this.all_blogger[i].displayname + "/" + this.all_blogger[i].articles.user;
                    this.paFunction(blogger_text, i + 1)
                }
            }
        },
        imgOnError(event) {
            event.target.src = 'https://www.pixnet.net/img/public/default/img_default_'+ this.random_default_img +'.png';
        }
    },
    watch: {
        category_id: async function() {
            if( this.rank_status == 1 ) {
                const params =  { page_size: 5, api_id: this.api_id, with_blog: 1, with_counter: 1, with_articles: 1, with_profile: 1, category_id: this.category_id }
                await this.$store.dispatch("blogger/getBloggerTopRankingData", params);
            } else {
                const params = { page_size: 5, api_id: this.api_id, with_blog: 1, with_counter: 1, with_articles: 1, with_profile: 1, category_id: this.category_id }
                await this.$store.dispatch("blogger/getBloggerNewRankingData", params);
            }
        }
    },
    async fetch(){
        let params;
        if (this.category_id != 0 && this.category_id != "" && this.category_id != undefined) {
            params = { page_size: 5, api_id: this.api_id, with_blog: 1, with_counter: 1, with_articles: 1, with_profile: 1, category_id: this.category_id }
        } else {
            params = { page_size: 5, api_id: this.api_id, with_blog: 1, with_counter: 1, with_articles: 1, with_profile: 1, channel_id: this.channel_id }
        }
        await this.$store.dispatch("blogger/getBloggerTopRankingData", params);
    }
}
